import React from "react";

const SegFooter = () => {
    return (
        <div className="w-full flex flex-col items-center bg-blue-600 py-5 space-y-2">
            <p className="text-white text-center">
                southerneyegroup.com | (251) 990-3937
            </p>
            <p className="text-white text-center">
                Atmore | Biloxi | Daphne | Fairhope | Foley | East Mobile | Midtown Mobile | West Mobile | Pensacola | Saraland | Spanish Fort
            </p>
        </div>
    );
};

export default SegFooter;
